module.exports = __webpack_public_path__ + "static/media/paintgif.68047261.gif";